import { z } from 'zod';
export const AppraiserAssignmentSchema = z.object({
    main: z.string(),
    secondary: z.string().optional(),
    tertiary: z.string().optional(),
});
